import { useEffect, useState } from "react"
import { Alert, Container, Table, Badge, Button } from "reactstrap"
import Utils from "../../../Utils"
import { Link } from "react-router-dom"

const CotiPendientes = () => {

    const [cotizaciones, setCotizaciones] = useState(null)
    
    const fetchCotizaciones = async () => {
        try {
            const { data } = await Utils.API.CotizacionesPendientes()
            setCotizaciones(data)
        } catch(err) {
            Utils.AlertError(err, "No se pudieron cargar las cotizaciones")
        }
    }

    const marcarAtencion = async (idCotizacion) => {
        if(window.confirm(`Realmente marcar la Cotizacion #${idCotizacion} como atendida?`)) {
            // try
            try {
                await Utils.API.AtenderCotizacion(idCotizacion)
                // refresh list
                fetchCotizaciones()
            } catch(err) {
                console.error(err)
                Utils.AlertError(err, "No se pudo marcar como atendido")
            }
        }
    }

    useEffect(() => {
        fetchCotizaciones()
    }, [])

    return(
        <Container>
            {(cotizaciones == null) ?
                <Alert className="text-center h3" color="info">Cargando...</Alert>
                :
                <>
                    {(cotizaciones.length > 0) ?
                    <>
                        <h1>Cotizaciones Pendientes: {cotizaciones.length}</h1>
                        <Table>
                            <thead>
                                <tr>
                                    <th>#Cotización</th>
                                    <th>Solicitante</th>
                                    <th>PrecioDolar</th>
                                    <th>Cuotas</th>
                                    <th>Inicial</th>
                                    <th>Reserva</th>
                                    <th>Lote</th>
                                    <th>Proyecto</th>
                                    <th>Asesor</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cotizaciones.map(coti => (
                                    <tr key={`coti_${coti.idCotizacion}`}>
                                        <td>{coti.idCotizacion}</td>
                                        <td>{coti.Nombre}</td>
                                        <td>S/.{coti.PrecioDolar}</td>
                                        <td>{coti.CantCuotas}</td>
                                        <td>{coti.Inicial}%</td>
                                        <td>{(coti.ConReserva == true) ?
                                            <>
                                                {(coti.GenerarCuotas == true) ?
                                                    <Badge tag={Link} to={`/Ventas/Pagos/${coti.idUsuario}`} color="success">Cuotas Generadas</Badge>
                                                    :
                                                    <Badge color="primary">Con Reserva</Badge>
                                                }
                                            </>
                                            :
                                            <Badge>Sin Reserva</Badge>
                                        }</td>
                                        <td>{coti.ManzanaLote}</td>
                                        <td>{coti.Proyecto}</td>
                                        <td>{(coti.Asesor == null) ?
                                            <Badge color="danger">Sin Asesor</Badge>
                                            :
                                            <>{coti.Asesor}</>
                                        }</td>
                                        <td>
                                            <Button tag="a" href={`tel:${coti.Celular}`} className="m-1" size="sm">
                                                <i className="fa-solid fa-phone"></i> Llamar
                                            </Button>
                                            <Button target="_blank" tag="a" href={`https://wa.me/51${coti.Celular}`} className="m-1" size="sm">
                                                <i className="fa-brands fa-whatsapp"></i> Whatsapp
                                            </Button>
                                            <Button onClick={() => { marcarAtencion(coti.idCotizacion) }} className="m-1" size="sm">
                                                <i className="fa-solid fa-check"></i> Marcar Atendido
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </>
                    :
                        <Alert className="text-center">Sin Cotizaciones pendientes</Alert>
                    }
                </>
            }
        </Container>
    )
}

export default CotiPendientes